
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartaIVldkCLgrvmK9w9aGzEDfNvoVBmFB_45gEfExexZmeFMMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/cart.vue?macro=true";
import { default as indexjSeKF09pM7R_45PkplThbST2r_TSqqjEsD5Zvwuy_by5YMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/index.vue?macro=true";
import { default as searchYuLv8Bpoy3EKnS1cWOL3zw7grxThFT49Vzlpcrl9QFMMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/search.vue?macro=true";
import { default as signinjmPLtzPWtIS5n6OcgHqO0LLm13V9_45iU8Ud_45P3wnfJysMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/signin.vue?macro=true";
import { default as registerYvgZsnL_9VjmELXRmKh0LngAMp6bcClFd1TD5EGOr9YMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/register.vue?macro=true";
import { default as infos2FHqNPdrA3XW_iQaxPWagzXvPJCTfPXGh8OuBjspM7EMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/infos.vue?macro=true";
import { default as phonesSUdTAZFtfcTmak_45dKWetgbfqzfzlttlV4GXTnxIH9L4Meta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/phones.vue?macro=true";
import { default as indexrjeCbF5wvC9qvcbEazKIFfpQJhHMvEEOm4P_45o3zKXncMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/p/[id]/index.vue?macro=true";
import { default as account8kqd8EeYscsRvhOoKAEsU3rCttrMckfMSB4e_456edXnwMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/account.vue?macro=true";
import { default as indexsdaxGQ8mHCZxIJzVcszUfJnXrJmvGm5q_0fbSRfcc4AMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/c/[slug]/index.vue?macro=true";
import { default as reviewsJf8voV2MH7L0A5p3JKaOYXY0524cNndRWeE4PG8H7J0Meta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/p/[id]/reviews.vue?macro=true";
import { default as addresses_45t_45ewjhQrLMJ6rvePPiMiFH90fGLvmAsTXC3Q_451kGlkMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/addresses.vue?macro=true";
import { default as contactCR0qdTy0491R1I1v6LstFVSUcLPSfcxc_45IzFo5am_VwMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/contact.vue?macro=true";
import { default as edit_45infos_45FcZLdNU5OcCMwMu_45UYovuFDaVdwVyRj5_lX7SwUO7MMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/edit-infos.vue?macro=true";
import { default as indexuNbKi7ojdKhKaoqo7h552vkJu3FzcsnuPayR8pjed7YMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/index.vue?macro=true";
import { default as testimonialszhX18pd3ughnNELivYh2z7F3t6snOyFcZS5R2RZUEiIMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/testimonials.vue?macro=true";
import { default as newsletterRXwhTADARfH2ppUTUSCLYGgDiaWGIIgWcuxhTZVTdHcMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/newsletter.vue?macro=true";
import { default as edit_45passwordiD_45oT5VsKmTyEFZskQpLG6pxY8SIB7Wf52ju_45w0ZzAsMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/edit-password.vue?macro=true";
import { default as _91id_93aSl5_45eS7jcR4utXTtn_OBk8IFwwT5L09NCU7KyTFPZEMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/invoices/[id].vue?macro=true";
import { default as createNDoG_45nb5KecmkYtuampRbp4G5h8FgMXmpRpUSkiVXN0Meta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/create.vue?macro=true";
import { default as indexM8_45nxpc01tvqBbxJPGJJte8YOEuKOD3ZJSHbINxOj2wMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/reviews/index.vue?macro=true";
import { default as indexv_yvfDTBJMtcuBQCA2RDz1SKC4aDMrtnlblF8vRQDUEMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/invoices/index.vue?macro=true";
import { default as _91_46_46_46content_93gOmY5BEt3qcy7EDou4y4S_45LRV1o9hU6DoUtmQDcf8DsMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/[...content].vue?macro=true";
import { default as testimonialsx6R1lZOR13PA_45QGoIqYwKVbrPR1JS_45UcdYrAinWfJUwMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/testimonials.vue?macro=true";
import { default as indexpjpRCMp278B4FY0vdcZFsOrVIeMlUYiFDtz_Yr6ivoIMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/reset-password/index.vue?macro=true";
import { default as informationsGOvhxKec8lWTSU6TS9LrcwRNaO07o5_45CT4BPDnauDtMMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/c/[slug]/informations.vue?macro=true";
import { default as request_45quoteKHdHMKpXq7HQx37JFDdx8I4HemDb_45NXhKkG69KOuobQMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/request-quote.vue?macro=true";
import { default as updateh6rMy57qT7Nf1HUbMwa42yPV5zKQM9EC_S9AbyqWLTYMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/reset-password/update.vue?macro=true";
import { default as indexTcTh18Hx1ZZZTczQxIrNkxuloxOkuQ8ljVJ49J9GWDUMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/[id]/index.vue?macro=true";
import { default as paymentABTrJKgs4mJKSGIqodCmsSr6MSA1m7uwbMYcMDUYDfEMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/[id]/payment.vue?macro=true";
import { default as indexvTq47iONO4RvPn3y4Bwr8Wj4Lrj2XT4N_kP2LQntVScMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/request-quotes/index.vue?macro=true";
import { default as _91product_id_93ATdi7yynVG7_071EIwf5dZ_457SC6aaGkz0hAiddyNSvMMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/reviews/[product_id].vue?macro=true";
import { default as unsubscribeehbyvp3BQj2EuKfRDWtQACrqJY8SeULa0e0tEXYPvbQMeta } from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/request-quotes/[quoteUuid]/unsubscribe.vue?macro=true";
import { default as indexBk9_45xhZkDOR7IiwiMwK_45g9kAyLKcSEnT108f90qNOcEMeta } from "~/pages/p/[id]/index.vue?macro=true";
import { default as reviewsgzwS70aXqoLFsZJY2crJq07oz8ItVflZYc3Hb6iSigsMeta } from "~/pages/p/[id]/reviews.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/search.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/signin.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/register.vue")
  },
  {
    name: "user-infos",
    path: "/user/infos",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/infos.vue")
  },
  {
    name: "user-phones",
    path: "/user/phones",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/phones.vue")
  },
  {
    name: "p-id",
    path: "/p/:id()",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/p/[id]/index.vue")
  },
  {
    name: "user-account",
    path: "/user/account",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/account.vue")
  },
  {
    name: "c-slug",
    path: "/c/:slug()",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/c/[slug]/index.vue")
  },
  {
    name: "p-id-reviews",
    path: "/p/:id()/reviews",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/p/[id]/reviews.vue")
  },
  {
    name: "user-addresses",
    path: "/user/addresses",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/addresses.vue")
  },
  {
    name: "company-contact",
    path: "/company/contact",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/contact.vue")
  },
  {
    name: "user-edit-infos",
    path: "/user/edit-infos",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/edit-infos.vue")
  },
  {
    name: "user-orders",
    path: "/user/orders",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/index.vue")
  },
  {
    name: "user-testimonials",
    path: "/user/testimonials",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/testimonials.vue")
  },
  {
    name: "company-newsletter",
    path: "/company/newsletter",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/newsletter.vue")
  },
  {
    name: "user-edit-password",
    path: "/user/edit-password",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/edit-password.vue")
  },
  {
    name: "user-invoices-id",
    path: "/user/invoices/:id()",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/invoices/[id].vue")
  },
  {
    name: "user-orders-create",
    path: "/user/orders/create",
    meta: createNDoG_45nb5KecmkYtuampRbp4G5h8FgMXmpRpUSkiVXN0Meta || {},
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/create.vue")
  },
  {
    name: "user-reviews",
    path: "/user/reviews",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/reviews/index.vue")
  },
  {
    name: "user-invoices",
    path: "/user/invoices",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/invoices/index.vue")
  },
  {
    name: "company-content",
    path: "/company/:content(.*)*",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/[...content].vue")
  },
  {
    name: "company-testimonials",
    path: "/company/testimonials",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/testimonials.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/reset-password/index.vue")
  },
  {
    name: "c-slug-informations",
    path: "/c/:slug()/informations",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/c/[slug]/informations.vue")
  },
  {
    name: "company-request-quote",
    path: "/company/request-quote",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/company/request-quote.vue")
  },
  {
    name: "reset-password-update",
    path: "/reset-password/update",
    meta: updateh6rMy57qT7Nf1HUbMwa42yPV5zKQM9EC_S9AbyqWLTYMeta || {},
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/reset-password/update.vue")
  },
  {
    name: "user-orders-id",
    path: "/user/orders/:id()",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/[id]/index.vue")
  },
  {
    name: "user-orders-id-payment",
    path: "/user/orders/:id()/payment",
    meta: paymentABTrJKgs4mJKSGIqodCmsSr6MSA1m7uwbMYcMDUYDfEMeta || {},
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/orders/[id]/payment.vue")
  },
  {
    name: "user-request-quotes",
    path: "/user/request-quotes",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/request-quotes/index.vue")
  },
  {
    name: "user-reviews-product_id",
    path: "/user/reviews/:product_id()",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/reviews/[product_id].vue")
  },
  {
    name: "user-request-quotes-quoteUuid-unsubscribe",
    path: "/user/request-quotes/:quoteUuid()/unsubscribe",
    component: () => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/pages/user/request-quotes/[quoteUuid]/unsubscribe.vue")
  },
  {
    name: "product-w-slug",
    path: "/p/:slug/:id",
    component: () => import("~/pages/p/[id]/index.vue")
  },
  {
    name: "product-by-ref",
    path: "/p/:slug/r/:ref",
    component: () => import("~/pages/p/[id]/index.vue")
  },
  {
    name: "product-by-ref-and-id",
    path: "/p/:slug/r/:ref/:id",
    component: () => import("~/pages/p/[id]/index.vue")
  },
  {
    name: "product-reviews-w-slug",
    path: "/p/:slug/:id/reviews",
    component: () => import("~/pages/p/[id]/reviews.vue")
  },
  {
    name: "products-deprecated",
    path: "/products/:id",
    component: () => import("~/pages/p/[id]/index.vue")
  }
]